import { component, computed } from 'knockout-decorators'

import source from './page-footer.html?raw'
import './page-footer.less'

import CreditCardImages from '../../images/cards.svg?raw'
import FacebookLogo from '../../images/logo-facebook.svg?raw'
import LogoImage from '../../images/logo-footer.svg?raw'
import InstagramLogo from '../../images/logo-instagram.svg?raw'
import TixaBlogLogo from '../../images/logo-tixablog.svg?raw'
import { Locale } from '~/utils/language'

import './hubspot-form'

const SimpleWhiteLogo = new URL(
  '../../images/simplepay_w240-white.png',
  import.meta.url
)

const KNHLogo = new URL('../../images/k&h_logo.png', import.meta.url).href

const SIMPLEPAY_INFO_URL_HU =
  'https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf'
const SIMPLEPAY_INFO_URL_OTHER =
  'https://simplepartner.hu/PaymentService/Payment_information.pdf'

@component('page-footer', source)
export class PageFooter {
  private logoImage = LogoImage
  private facebookLogo = FacebookLogo
  private instagramLogo = InstagramLogo
  private blogLogo = TixaBlogLogo
  private creditCardImages = CreditCardImages
  private simpleLogo = SimpleWhiteLogo
  private knhLogo = KNHLogo

  @computed get simplePayInfoUrl(): string {
    return Locale.language === 'hu'
      ? SIMPLEPAY_INFO_URL_HU
      : SIMPLEPAY_INFO_URL_OTHER
  }
}
